import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-objectives',
  templateUrl: './objectives.component.html',
  styleUrls: ['./objectives.component.scss']
})
export class ObjectivesComponent implements OnInit {
  @Input() public projectName: string;
  icon: string;
  optionObjetive: boolean;
  optionSubObjetive: boolean;
  mostrar: any;
  objetive= [{
    id: "Tecnología",
    objetives:[{
        id: 1,
        objetiveName: "Mejorar el funcionamiento de los procesos de procura",
        SubObjetive: [
          {
            SubObjetiveName: 'realizar auditorías',
          },
          {
            SubObjetiveName: 'inspeccionar los procesos actuales ',
          },
          {
            SubObjetiveName: 'realizar una matriz de responsabilidades/roles',
          },
          {
            SubObjetiveName: 'Implementación de las actualizaciones metodológicas',
          },
          {
            SubObjetiveName: 'actualización de software',
          },
          {
            SubObjetiveName: 'actualizaciones de equipos',
          },
          {
            SubObjetiveName: 'capacitaciones',
          },
        ]
      },{
        id: 2,
        objetiveName: 'inspeccionar los procesos actuales',
        SubObjetive:'',
      }
    ]
  }];
  constructor() { }

  ngOnInit() {
    this.icon="fa fa-angle-right float-right";
    this.optionObjetive = true;
    this.optionSubObjetive = true;
    this.mostrarLista()
  }
  mostrarLista(){
    if (this.projectName === "Tecnología"){
      this.mostrar= true;
      }else{
      this.mostrar= false;
    }
  }
  changeIcon(){
    switch (this.icon) {
      case "fa fa-angle-right float-right":
        this.icon="fa fa-angle-down float-right";
      break;
      case "fa fa-angle-down float-right":
          this.icon="fa fa-angle-right float-right";
      break;
    }
  }
}
